/*
 * $Id:: StepOne.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { t } from '../../../../providers';
import { initEgovLogin } from '../../service';
import eValdziaLogo from '../../../../assets/images/eValdzia-logo.png';

const useStyles = makeStyles(() => ({
    portalLink: {},
    mainLogo: {
        paddingRight: '15px',
        float: 'left',
        maxWidth: '68px',
    },
    logoTitle: {
        fontSize: '30px',
        fontWeight: '700',
        lineHeight: '1',
        marginBottom: '2px',
        color: '#006D9B',
        float: 'left',
    },
    logoText: {
        lineHeight: '1.4',
        fontSize: '15px',
        color: '#2A6085',
        float: 'left',
    },
    infoGrid: {
        marginTop: '50px',
    },
    mainDiv: {
        maxWidth: '70%',
    }
}));

const StepOne = () => {
    const classes = useStyles();

    const [ticket, setTicket] = useState('');
    const [authenticationUrl, setAuthenticationUrl] = useState('');
    const [errorMessageKey, setErrorMessageKey] = useState(new URLSearchParams(window.location.search).get('errorMessageKey'));

    const initAuth = () => {
        const callbackUrl = window.location.protocol + '//' + window.location.host + '/epaslaugos/auth/callback/new-account';
        const loginChallenge = new URLSearchParams(window.location.search).get('login_challenge');
        initEgovLogin({callbackUrl: callbackUrl, loginChallenge: loginChallenge}).then(({ticket, authenticationUrl})=>{
            if(!!ticket && !!authenticationUrl){
                setTicket(ticket);
                setAuthenticationUrl(authenticationUrl);
                document.getElementById('authentication_init_form').submit();
            } else {
                setErrorMessageKey('service.unavailable');
            }
        });
    };

    return (
        <div className={classes.mainDiv}>
            <div>
                <a href="#" onClick={initAuth}>
                    <div>
                        <img src={eValdziaLogo} className={classes.mainLogo} />
                    </div>
                    <div>
                        <div className={classes.logoTitle}>{t('e.government.gateway')}</div>
                        <div className={classes.logoText}>{t('e.government.gateway.description')}</div>
                    </div>
                </a>
            </div>

            <Grid container>
                <Typography color="error">{t(errorMessageKey)}</Typography>
            </Grid>

            <form id="authentication_init_form" noValidate method="post" action={authenticationUrl}>
                <input type="hidden" id="ticket" name="ticket" value={ticket}/>
            </form>
            <Grid container className={classes.infoGrid}>
                <Typography><strong>{t('registration.info')}</strong></Typography>
            </Grid>
        </div>
    );
};

export default StepOne;
